import { useState } from 'react';
import Select from 'react-select';
import Icon from '../icons';

const SelectAssistant = ({ handleDoneClick, saveThirdPartyFiles, selectionData, onClose, optionSelect, hidebtn, files, onRemoveFile }) => {
    const [assistantError, setAssistantError] = useState(false)
    const [selectedOption, setSelectedOption] = useState([]);
    const [loader, setLoader] = useState(false);

    const handleAssistantSelect = (e) => {
        setSelectedOption(e)
    }

    const handlesave = (e) => {
        e.preventDefault();
        if (selectedOption.length > 0) {
            setLoader(true);
            if (optionSelect === "mediaLibrary") {
                handleDoneClick(selectedOption, setLoader)
            }

            if (optionSelect === "saveThirdPartyFiles") {
                saveThirdPartyFiles(selectedOption, setLoader)
            }

            localStorage.removeItem('uploadedFiles');
            setAssistantError(false)
        } else {
            setAssistantError(true)
        }
    }
    return (
        <div>
            <div style={{ marginBottom: "10px" }}>
                <b>Select Assistants</b>
            </div>

            {files?.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        margin: "0 20px 10px",
                    }}
                >
                    <span
                        style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#555",
                        }}
                    >
                        Selected File
                    </span>
                    {files.map((file, index) => (
                        <div
                            key={index}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "6px",
                                background: "#F4F4F4",
                                border: "1px solid #E5E5E5",
                                borderRadius: "8px",
                                padding: "12px 14px",
                                fontSize: "14px",
                                width: "100%",
                            }}
                        >
                            <span
                                title={file?.name}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    flex: 1,
                                }}
                            >
                                <Icon id="KBfile" />
                                <span
                                    style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {file?.name || "Untitled file"}
                                </span>
                            </span>

                        </div>
                    ))}
                </div>
            )}

            <div>
                {assistantError ? <span style={{ color: "red" }}>Please select an AI Agent *</span> : ""}
                <Select
                    closeMenuOnSelect={true}
                    isMulti
                    options={selectionData?.filter(item => !item.readonly)?.map((item) => ({
                        label: item.assistant_name,
                        value: item.assistant_id
                    }))}
                    onChange={handleAssistantSelect}
                    styles={{
                        control: (base) => ({
                            ...base,
                            borderColor: "#E5E5E5",  // Custom border color
                            margin: '20px'  // Add margin of 20px
                        })
                    }}  // Custom border color
                />
            </div>

            <div className="text-right">
                {/* Conditionally render the buttons based on the hidebtn prop */}
                {!hidebtn && (
                    <>
                        <button className="px-2 mx-2 cancelbutton" disabled={loader} onClick={onClose}>
                            Cancel
                        </button>
                        <button onClick={handlesave} className="uploadbutton" disabled={loader}>
                            {loader && (
                                <Icon
                                    id="spinner"
                                    styles={{ verticalAlign: 'inherit', marginRight: '6px' }}
                                    color="#fff"
                                    width="15px"
                                    height="15px"
                                />
                            )}
                            Continue
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default SelectAssistant;
